module.exports = __webpack_public_path__ + "static/media/SCALE_Screen1.9c7e925b.png";